module.exports = __webpack_public_path__ + "static/media/fruits_19.e0035bf8.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_19.csv
// module id = 683
// module chunks = 0